import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { smoothlyMenu } from '../layouts/Helpers';
import LogoImg from '../../../public/img/logo.png';

class TopHeader extends Component {

  toggleNavigation(e) {
    e.preventDefault();
    $('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }

  render() {
    const showSideBtn = () => {
      if (this.props.sideBtn) {
        return (
          <button
            onClick={this.toggleNavigation}
            className='navbar-minimalize minimalize-styl-2 btn btn-primary hidden visible-xs'
          >
            <FontAwesomeIcon icon="bars" />
          </button>
        );
      }
      return null;
    };

    return (
      <div className='row border-bottom'>
        <Navbar collapseOnSelect fluid fixedTop role='navigation'>
          <Navbar.Header>
            {showSideBtn()}
            <Navbar.Brand>
              <a href='/'>
                <img
                src={LogoImg}
                alt='logo'
                className='img-responsive'
                style={{ height: 35 }}
                />
              </a>
            </Navbar.Brand>
            <Navbar.Toggle>
              <FontAwesomeIcon icon="bars" />
            </Navbar.Toggle>
          </Navbar.Header>

          <Navbar.Collapse>
            {this.props.children}
          </Navbar.Collapse>

        </Navbar>
      </div>
    );
  }
}

export default TopHeader;
